// /locked (docs/08-app-design.md 5.3; app/art/welcome/PLAN.md section 4.3):
// the device passphrase opens the sealed master inside the worker. The
// entrance frame with the small still and the DeviceDoor that the occupied
// /welcome shares; only the lede is this route's own. A wrong passphrase
// changes nothing on chain and says so; the escape hatch is to forget this
// device, which only deletes local storage (the 24 words still open the
// vault anywhere). The pending and blocked forget states (R59, R60, R62)
// live in DeviceDoor, unchanged. An unlocked session goes straight on to
// /vault, as Welcome does: so a door left by Back whose unlock still lands
// (R68 residual) never leaves the session unlocked under a fresh door.

import { useEffect } from 'react';
import { Redirect, useLocation } from 'wouter';
import { DeviceDoor } from '../components/DeviceDoor';
import { EntranceArt } from '../components/EntranceArt';
import { EntranceFrame } from '../components/EntranceFrame';
import { useSession } from '../session';

export function Locked() {
  const [, navigate] = useLocation();
  const { state } = useSession();

  // A blocked forget's queued deletion completes on its own once the other tab closes; the session then says the
  // device is empty, and this screen has nothing left to lock (R60).
  useEffect(() => {
    if (state === 'no-vault') navigate('/welcome');
  }, [state, navigate]);

  // until the session has read storage, the column is reserved and empty, as on /welcome
  if (state === 'starting') return <EntranceFrame art={<EntranceArt size="small" />} busy />;
  // unlocked, whichever door's unlock landed (this one's own navigates the same way): the vault, replacing this entry
  if (state === 'unlocked') return <Redirect to="/vault" replace />;

  return (
    <EntranceFrame art={<EntranceArt size="small" />}>
      <DeviceDoor lede="Enter this device’s passphrase to open your vault." onForgotten={() => navigate('/welcome')} />
    </EntranceFrame>
  );
}
